import { apiErrorMessage } from './apiErrorMessage';

const failure = 'Client Synthesis generation failed. Please try again.';
export const clientSynthesisErrorText = (payload, fallback = failure) =>
  apiErrorMessage({ response: { data: payload } }, fallback);

// A fetch chunk is not necessarily a complete SSE line. Keep partial lines
// until the next read, and require the server's saved-success event.
export async function readClientSynthesisStream(response, onProgress) {
  if (!response.ok) {
    const text = await response.text();
    let payload;
    try { payload = JSON.parse(text); } catch { payload = null; }
    throw new Error(clientSynthesisErrorText(payload, `Client Synthesis request failed (HTTP ${response.status}). Please try again.`));
  }
  if (!response.headers.get('content-type')?.includes('text/event-stream') || !response.body) {
    throw new Error('Unexpected Client Synthesis response. Please try again.');
  }
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let pending = '';
  let completed = false;
  const consume = (line) => {
    if (!line.startsWith('data:')) return;
    let event;
    try { event = JSON.parse(line.slice(5).trim()); } catch {
      throw new Error('Invalid Client Synthesis response. Please try again.');
    }
    if (!event || typeof event !== 'object' || Array.isArray(event)) {
      throw new Error('Invalid Client Synthesis response. Please try again.');
    }
    if (event.type === 'error') throw new Error(clientSynthesisErrorText(event));
    if (event.type === 'complete') completed = true;
    if (event.type === 'metadata') onProgress('Starting AI generation...');
    if (event.type === 'progress' && typeof event.message === 'string') onProgress(event.message);
  };
  try {
    while (!completed) {
      const { done, value } = await reader.read();
      pending += decoder.decode(value, { stream: !done });
      const lines = pending.split('\n');
      pending = lines.pop();
      for (const line of lines) consume(line.replace(/\r$/, ''));
      if (done) {
        if (pending.trim()) consume(pending);
        break;
      }
    }
    if (!completed) throw new Error('Client Synthesis connection ended before completion. Please refresh to check the saved report before retrying.');
  } finally {
    await reader.cancel().catch(() => {});
    reader.releaseLock();
  }
}
